<!-- eslint-disable vue/valid-v-slot -->
<template>
  <v-container fluid class="caso-component">
    <v-flex xs12 class="text-center justify-center mb-4 mt-6">
      <h4 class="font-weight-bold">LISTA DE CASOS ARCHIVADOS</h4>
    </v-flex>
    <v-card>
      <v-card-text>
        <filtros
          ref="criterios"
          :campos.sync="camposfiltros"
          @actualizarFiltro="getInfo"
          @nuevo="addUpdate"
        ></filtros>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :options.sync="options"
      :loading="loading"
      class="elevation-1"
      :dense="true"
      no-data-text="Datos no disponibles"
      no-results-text="Cargando..."
      fixed-header
      :height="500"
      :footer-props="{
        'show-current-page': false,
        'show-first-last-page': false,
        'items-per-page-options': [],
        'items-per-page-text': '',
      }"
      :disable-sort="true"
    >
      <template v-slot:footer.page-text>
        <v-row justify="end" align="center" class="ma-0 pa-0">
          <v-col class="col-content-footer">
            <v-btn
              type="button"
              :loading="loading"
              class="v-btn v-btn--icon v-btn--round v-btn--text theme--light v-size--default"
              :disabled="paginas.length === 0"
              @click="getDataAnterior"
              aria-label="Previous page"
            >
              <span class="v-btn__content">
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mdi mdi-chevron-left theme--light"
                ></i>
              </span>
            </v-btn>
            <v-btn
              type="button"
              :loading="loading"
              :disabled="!ultimoDocumento"
              @click="getDataSiguiente"
              class="v-btn v-btn--icon v-btn--round v-btn--text theme--light v-size--default"
              aria-label="Next page"
            >
              <span class="v-btn__content">
                <i
                  aria-hidden="true"
                  class="v-icon notranslate mdi mdi-chevron-right theme--light"
                ></i>
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:top>
        <v-toolbar flat></v-toolbar>
      </template>
      <template v-slot:[`item.origen_desde`]="{ item }">
        <v-chip
          :color="item.origen_desde == 'Digipats' ? 'success' : 'warning'"
          >{{ item.origen_desde }}</v-chip
        >
      </template>
      <template v-slot:[`item.perito`]="{ item }">
        {{ item.perito }}
        <v-badge
          v-if="!item.perito && item.solicitud_perito"
          dot
          inline
          color="orange"
        >
          Solicitando
        </v-badge>
      </template>
      <template v-slot:[`item.dibujante`]="{ item }">
        {{ item.dibujante }}
        <v-badge
          v-if="!item.dibujante && item.solicitud_dibujante"
          dot
          inline
          color="orange"
        >
          Solicitando
        </v-badge>
      </template>
      <template v-slot:[`item.archivar`]="{ item }">
        <v-chip
          v-if="item.archivado"
          small
          class="ma-2"
          :title="item.archivado ? 'Restablecer Caso' : 'Archivar Caso'"
          color="red"
          outlined
          @click="archivar(item)"
        >
          <v-icon small> mdi-power </v-icon>
        </v-chip>
      </template>
      <template v-slot:[`item.infoCaso`]="{ item }">
        <v-btn
          @click="infoCaso(item)"
          color="primary"
          title="Información del caso"
          small
          icon
          text
          outlined
        >
          <v-icon small>mdi-magnify</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <!-- <modal-add
      v-if="showModal"
      :showModal.sync="showModal"
      :id="id"
      @actualizar="getData"
    ></modal-add> -->
    <modal-afectado
      v-if="showModalAfectado"
      :showModal.sync="showModalAfectado"
      :id="id"
    >
    </modal-afectado>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { db } from "../../firebase";
import Filtros from "../General/Filtros.vue";
// import ModalAdd from "./ModalAdd.vue";
import ModalAfectado from "./ModalUsuarioAfectado.vue";
import moment from "moment";

export default {
  components: {
    Filtros,
    ModalAfectado,
  },
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Casos",
  data() {
    return {
      coleccion: "casos",
      consulta: "",
      condicion: "",
      campo: "",
      totalItems: 0,
      lastVisible: "",
      itemsPerPage: 0,
      ordenar: "",
      typoOrdenar: false,
      page: 0,
      options: {},
      camposfiltros: [],
      campoFiltro: "",
      operadorFiltro: "",
      valorFiltro: "",
      criterios: [],
      search: "",
      loading: true,
      desserts: [],
      showModal: false,
      id: "",
      headers: [
        { text: "Caso", value: "caso" },
        { text: "Cliente", value: "cliente" },
        { text: "Info caso", value: "infoCaso" },
        { text: "Ciudad siniestro", value: "ciudad_siniestro" },
        { text: "Origen", value: "origen_desde" },
        { text: "Tipo de caso", value: "tipocaso" },
        { text: "Tipo de plan", value: "tipo_plan" },
        { text: "Vehículo", value: "vehiculo" },
        { text: "Placa", value: "placa", align: " d-none" },
        // { text: "Localizacion", value: "localizacion" },
        { text: "Call Center", value: "callcenter" },
        { text: "Abogado", value: "abogado" },
        { text: "Investigador", value: "investigador" },
        { text: "Perito", value: "perito" },
        { text: "Dibujante", value: "dibujante" },
        { text: "Estado", value: "estado" },
        { text: "Fecha Creación", value: "creado" },
        { text: "Activar", value: "archivar" },
      ],
      showModalAsignar: false,
      showModalSolicitar: false,
      showModalAfectado: false,
      listaUsuarios: [],
      listaClientes: [],
      listaVehiculos: [],
      tomarCaso: [],
      idCiudad: "",
      estadoUsuarioLogueado: "",
      tipoPlanCaso: "",
      numero_caso: "",
      uidcontactcenter: "",
      datosCaso: {},
      agentes: [
        "uidabogado",
        "uidinvestigador",
        "uidabogadocait",
        "uidcontactcenter",
        "uidperito",
      ],
      campoAgente: "",
      consultaAgente: "",
      cargoAgente: "",
      estadoAgente: "",
      ultimoDocumento: null,
      primerDocumento: null,
      unsubscribe: null,
      camposNumericos: ["caso"],
      querySnapshot: [],
      paginas: [],
    };
  },
  computed: {
    ...mapState(["drawer", "logueado"]),
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
    },
    cargo: {
      get() {
        return `${this.logueado.cargo}`;
      },
    },
    user() {
      return this.$store.getters.user;
    },
    autorizaCrear() {
      return this.logueado.cargo === "Call Center" ||
        this.logueado.cargo === "Coordinador Contact Center" ||
        this.logueado.cargo === "Administrador"
        ? true
        : false;
    },
  },
  async mounted() {
    this.headers.forEach((element) => {
      if (element.value === "caso" || element.value === "placa") {
        this.camposfiltros.push({
          campo: element.value,
          etiqueta: element.text,
        });
      }
    });
    await this.getInfo();
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  watch: {
    options: {
      async handler() {
        await this.filtros();
      },
      deep: true,
    },
    async tomarCaso(nuevo, old) {
      const parametro = {};
      if (nuevo.length > old.length) {
        console.log("agregar");
        if (this.cargo == "Investigador")
          parametro.uidinvestigador = this.logueado.id;
        if (this.cargo == "Abogado") parametro.uidabogado = this.logueado.id;
        if (this.cargo == "Dibujante")
          parametro.uiddibujante = this.logueado.id;
        this.id = nuevo[nuevo.length - 1];
        await db.collection("casos").doc(this.id).update(parametro);
        this.trazabilidad("tomo el ");
        this.enviarNotificacion(
          `${this.cargo}`,
          `${this.logueado.nombres} ${this.logueado.apellidos}`
        );
      } else if (nuevo.length < old.length) {
        console.log("quitar");
        if (this.cargo == "Investigador") parametro.uidinvestigador = "";
        if (this.cargo == "Abogado") parametro.uidabogado = "";
        if (this.cargo == "Dibujante") parametro.uiddibujante = "solicitado";
        old.forEach((el) => {
          if (nuevo.includes(el)) return;
          this.id = el;
        });
        await db.collection("casos").doc(this.id).update(parametro);
        this.trazabilidad("se desvinculo del ");
      }
    },
  },
  created() {
    if (
      this.logueado.cargo == "Administrador" ||
      this.logueado.cargo == "Coordinador Contact Center" ||
      this.logueado.cargo == "Coordinador Investigador" ||
      this.logueado.cargo == "Coordinador Abogado" ||
      this.logueado.cargo == "Coordinador Abogado CAIT"
    ) {
      this.consulta = 0;
      this.campo = "caso";
      this.condicion = ">";
    }
    if (this.logueado.cargo == "Call Center") {
      this.consulta = this.logueado.id;
      this.campo = "uidcontactcenter";
      this.condicion = "==";
    }
    if (this.logueado.cargo == "Investigador") {
      this.consulta = [this.logueado.id];
      this.campo = "uidinvestigador";
      this.condicion = "in";
    }
    if (this.logueado.cargo == "Abogado") {
      this.consulta = [this.logueado.id, ""];
      this.campo = "uidabogado";
      this.condicion = "in";
    }
    if (this.logueado.cargo == "Dibujante") {
      this.consulta = [this.logueado.id, "solicitado"];
      this.campo = "uiddibujante";
      this.condicion = "in";
    }
    if (this.logueado.cargo == "Abogado CAIT") {
      this.consulta = [this.logueado.id, ""];
      this.campo = "uidabogadocait";
      this.condicion = "in";
    }
    if (this.logueado.cargo == "Coordinador Perito") {
      this.consulta = true;
      this.campo = "solicitud_perito";
      this.condicion = "==";
    }
    if (this.logueado.cargo == "Perito") {
      this.consulta = this.logueado.id;
      this.campo = "uidperito";
      this.condicion = "==";
    }
  },
  methods: {
    ...mapActions("notification", ["EnviarNotificaciones"]),
    ...mapActions("trazabilidad", ["trazabilidadEstadoUsuarios"]),
    // eslint-disable-next-line no-unused-vars
    async filtros() {
      const { sortBy, sortDesc } = this.options;
      this.ordenar = sortBy[0] || this.headers[0].value;
      this.typoOrdenar = sortDesc[0] ? "asc" : "desc";
      this.criterios = await this.$refs.criterios.enviarCriterios();

      if (this.criterios.length > 0 && this.criterios[0]?.valor) {
        this.criterios.forEach((element) => {
          if (element.campo && element?.valor) {
            this.campoFiltro = element.campo;
            this.operadorFiltro = element.operador;
            this.valorFiltro = element?.valor;
          }
        });
      }
    },
    async getInfo() {
      try {
        await this.filtros();
        this.loading = true;
        let consulta = db
          .collection("casos")
          .where(this.campo, this.condicion, this.consulta)
          .where("archivado", "==", true);

        if (this.criterios.length > 0 && this.criterios[0]?.valor) {
          consulta = consulta.where(
            this.campoFiltro,
            this.operadorFiltro,
            this.camposNumericos.includes(this.campoFiltro)
              ? parseInt(this.valorFiltro || 0)
              : this.valorFiltro?.toUpperCase().trim()
          );
        }

        if (!this.criterios[0]?.valor) {
          consulta = consulta.orderBy("caso", "desc");
        }

        consulta = consulta.limit(10);

        this.unsubscribe = consulta.onSnapshot(async (querySnapshot) => {
          this.querySnapshot = querySnapshot;
          await this.procesarQuerySnapshot();
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    async getDataSiguiente() {
      if (!this.ultimoDocumento) return;
      try {
        this.loading = true;
        await this.filtros();
        let consulta = db
          .collection(this.coleccion)
          .where("archivado", "==", true);

        if (this.criterios.length > 0 && this.criterios[0]?.valor) {
          consulta = consulta.where(
            this.campoFiltro,
            this.operadorFiltro,
            this.valorFiltro
          );
        } else {
          consulta = consulta.orderBy("caso", "desc");
        }

        consulta = consulta.limit(10).startAfter(this.ultimoDocumento);

        this.unsubscribe = consulta.onSnapshot(async (querySnapshot) => {
          if (!querySnapshot.empty) {
            this.querySnapshot = querySnapshot;
            this.paginas.push(this.primerDocumento);
            await this.procesarQuerySnapshot();
          }
        });
      } catch (error) {
        console.error("Error al obtener datos siguientes:", error);
        this.handleError(error);
      }
    },
    async getDataAnterior() {
      if (this.paginas.length === 0) return;
      try {
        this.loading = true;
        await this.filtros();
        let consulta = db
          .collection(this.coleccion)
          .where("archivado", "==", true);

        if (this.criterios.length > 0 && this.criterios[0]?.valor) {
          consulta = consulta.where(
            this.campoFiltro,
            this.operadorFiltro,
            this.valorFiltro
          );
        } else {
          consulta = consulta.orderBy("caso", "desc");
        }

        const documentoAnterior = this.paginas.pop();
        consulta = consulta.limit(10).startAt(documentoAnterior);

        this.unsubscribe = consulta.onSnapshot(async (querySnapshot) => {
          if (!querySnapshot.empty) {
            this.querySnapshot = querySnapshot;
            await this.procesarQuerySnapshot();
          }
        });
      } catch (error) {
        console.error("Error al obtener datos anteriores:", error);
        this.handleError(error);
      }
    },
    async procesarQuerySnapshot() {
      const datos = await Promise.all(
        this.querySnapshot.docs.map(async (doc) => {
          const cliente =
            doc.data().uidcliente &&
            (await this.BuscarRegistro(doc.data().uidcliente, "clientes"));

          const abogado =
            doc.data().uidabogado &&
            (await this.BuscarRegistro(doc.data().uidabogado, "usuarios"));
          doc.data().uidabogado &&
            this.logueado.cargo == "Abogado" &&
            this.tomarCaso.push(doc.id);
          const dibujante =
            doc.data().uiddibujante != "solicitado" &&
            doc.data().uiddibujante &&
            (await this.BuscarRegistro(doc.data().uiddibujante, "usuarios"));
          doc.data().uiddibujante != "solicitado" &&
            doc.data().uiddibujante &&
            this.logueado.cargo == "Dibujante" &&
            this.tomarCaso.push(doc.id);
          const callcenter =
            doc.data().uidcontactcenter &&
            (await this.BuscarRegistro(
              doc.data().uidcontactcenter,
              "usuarios"
            ));
          const investigador =
            doc.data().uidinvestigador &&
            (await this.BuscarRegistro(doc.data().uidinvestigador, "usuarios"));
          doc.data().uidinvestigador &&
            this.logueado.cargo == "Investigador" &&
            this.tomarCaso.push(doc.id);
          const perito =
            doc.data().uidperito &&
            (await this.BuscarRegistro(doc.data().uidperito, "usuarios"));
          const vehiculo =
            doc.data().uidvehiculo &&
            (await this.BuscarRegistro(doc.data().uidvehiculo, "vehiculos"));

          return {
            id: doc.id,
            ...doc.data(),
            cliente: cliente
              ? `${cliente.nombres} ${cliente.apellidos} ${cliente.identificacion}`
              : "",
            abogado: abogado
              ? `${abogado.nombres} ${abogado.apellidos} ${abogado.identificacion}`
              : "",
            dibujante: dibujante
              ? `${dibujante.nombres} ${dibujante.apellidos} ${dibujante.identificacion}`
              : "",
            callcenter: callcenter
              ? `${callcenter.nombres} ${callcenter.apellidos} ${callcenter.identificacion}`
              : "",
            investigador: investigador
              ? `${investigador.nombres} ${investigador.apellidos} ${investigador.identificacion}`
              : "",
            perito: perito
              ? `${perito.nombres} ${perito.apellidos} ${perito.identificacion}`
              : "",
            vehiculo: vehiculo
              ? `Placa: ${vehiculo.placa} Marca: ${vehiculo.marca}`
              : "",
            creado: moment(doc.data().creado).format("YYYY-MM-DD HH:mm:ss"),
          };
        })
      );

      this.desserts = datos;
      this.ultimoDocumento =
        this.querySnapshot.docs[this.querySnapshot.docs.length - 1];
      this.primerDocumento = this.querySnapshot.docs[0];
      this.loading = false;
    },
    async getData() {
      //TODO: CORREGIR Parmejorar la velocidad de la consulta
      db.collection(this.coleccion)
        .where(this.campo, this.condicion, this.consulta)
        .where("archivado", "==", true)
        .get()
        .then((res) => {
          this.totalItems = res.size;
        });
      const { itemsPerPage, page, sortBy, sortDesc } = this.options;
      this.itemsPerPage = itemsPerPage;
      this.ordenar = sortBy[0] || this.headers[0].value;
      this.typoOrdenar = sortDesc[0] ? "asc" : "desc";
      this.criterios = await this.$refs.criterios.enviarCriterios();
      if (this.criterios.length > 0 && this.criterios[0].valor) {
        this.criterios.forEach((element) => {
          if (element.campo && element.valor) {
            this.campoFiltro = element.campo;
            this.operadorFiltro = element.operador;
            // eslint-disable-next-line
            this.valorFiltro = element.campo != "caso" ? element.valor.toUpperCase().trim() : parseInt(element.valor, 10);
          }
        });
      }
      try {
        if (this.criterios.length > 0 && this.criterios[0].valor) {
          this.buscarCuando();
        } else if (page == 1) {
          console.log("inicio");
          this.inicio();
        } else if (this.page < page) {
          console.log("siguiente");
          this.siguiente();
        } else {
          console.log("anterior");
          this.anterior();
        }
        this.page = page;
        this.loading = false;
      } catch (err) {
        this.handleError(err);
      }
    },
    async trazabilidad(nota) {
      try {
        // se consulta para saber el estado del asesor logueado
        db.collection("casos")
          .where(this.campo, "==", this.logueado.id)
          .where("archivado", "==", true)
          .where("estado", "not-in", [
            "Cancelado",
            "Conciliado",
            "No conciliado",
            "CERRADO",
          ])
          .get()
          .then((res) => {
            this.estadoUsuarioLogueado =
              res.size > 1 ? "Activo multiple" : "Activo ocupado";
            // se actualiza el estado del usuario logueado
            db.collection("usuarios")
              .doc(this.logueado.id)
              .update({ disponibilidad: this.estadoUsuarioLogueado })
              .then(() => {
                this.$store.dispatch("updatePerfilLogueado", {
                  id: this.logueado.id,
                });
              });
            // se guarda la trazabilidad del caso
            this.$store.dispatch("trazabilidadCaso", {
              descripcion: `El ${this.cargo} ${nota} caso`,
              uidcaso: this.id,
              uidcreador: this.logueado.id,
            });
            this.$store.dispatch("trazabilidadEstadoUsuarios", {
              descripcion: `El ${this.cargo} ${nota} caso`,
              estado: this.estadoUsuarioLogueado,
              uidcaso: this.id,
              cargo: this.logueado.cargo,
              uidcreador: this.logueado.id,
              uidusuario: this.logueado.id,
            });
          });
      } catch (error) {
        this.handleError(error);
      }
    },
    async BuscarRegistro(id, tabla) {
      const registro = await db.collection(tabla).doc(id).get();
      if (registro.empty) {
        return {};
      }
      return registro.data();
    },
    asignar(item) {
      this.idCiudad = item.uidciudad;
      this.id = item.id;
      this.showModalAsignar = true;
    },
    solicitar(item) {
      this.tipoPlanCaso = item.tipo_plan;
      this.id = item.id;
      this.showModalSolicitar = true;
    },
    async gestionar(e) {
      localStorage.setItem("id", e.id);
      this.$router.push(`/gestionar-caso/${e.id}/chat`);
    },
    async buscarCuando() {
      db.collection(this.coleccion)
        .where(this.campoFiltro, this.operadorFiltro, this.valorFiltro)
        .where(this.campo, this.condicion, this.consulta)
        .where("archivado", "==", true)
        .limit(this.itemsPerPage)
        .get()
        .then(async (resul) => {
          this.lastVisible = resul.docs[resul.docs.length - 1] || null;
          this.firstVisible = resul.docs[0] || null;
          const res = await Promise.all(
            resul.docs.map(async (doc) => {
              const cliente =
                doc.data().uidcliente &&
                (await this.BuscarRegistro(doc.data().uidcliente, "clientes"));
              const abogado =
                doc.data().uidabogado &&
                (await this.BuscarRegistro(doc.data().uidabogado, "usuarios"));
              doc.data().uidabogado &&
                this.logueado.cargo == "Abogado" &&
                this.tomarCaso.push(doc.id);
              const dibujante =
                doc.data().uiddibujante != "solicitado" &&
                doc.data().uiddibujante &&
                (await this.BuscarRegistro(
                  doc.data().uiddibujante,
                  "usuarios"
                ));
              doc.data().uiddibujante != "solicitado" &&
                doc.data().uiddibujante &&
                this.logueado.cargo == "Dibujante" &&
                this.tomarCaso.push(doc.id);
              const callcenter =
                doc.data().uidcontactcenter &&
                (await this.BuscarRegistro(
                  doc.data().uidcontactcenter,
                  "usuarios"
                ));
              const investigador =
                doc.data().uidinvestigador &&
                (await this.BuscarRegistro(
                  doc.data().uidinvestigador,
                  "usuarios"
                ));
              doc.data().uidinvestigador &&
                this.logueado.cargo == "Investigador" &&
                this.tomarCaso.push(doc.id);
              const perito =
                doc.data().uidperito &&
                (await this.BuscarRegistro(doc.data().uidperito, "usuarios"));
              const vehiculo =
                doc.data().uidvehiculo &&
                (await this.BuscarRegistro(
                  doc.data().uidvehiculo,
                  "vehiculos"
                ));

              return {
                id: doc.id,
                ...doc.data(),
                cliente: cliente
                  ? `${cliente.nombres} ${cliente.apellidos} ${cliente.identificacion}`
                  : "",
                abogado: abogado
                  ? `${abogado.nombres} ${abogado.apellidos} ${abogado.identificacion}`
                  : "",
                dibujante: dibujante
                  ? `${dibujante.nombres} ${dibujante.apellidos} ${dibujante.identificacion}`
                  : "",
                callcenter: callcenter
                  ? `${callcenter.nombres} ${callcenter.apellidos} ${callcenter.identificacion}`
                  : "",
                investigador: investigador
                  ? `${investigador.nombres} ${investigador.apellidos} ${investigador.identificacion}`
                  : "",
                perito: perito
                  ? `${perito.nombres} ${perito.apellidos} ${perito.identificacion}`
                  : "",
                vehiculo: vehiculo
                  ? `Placa: ${vehiculo.placa} Marca: ${vehiculo.marca}`
                  : "",
                creado: moment(doc.data().creado).format("YYYY-MM-DD HH:mm:ss"),
              };
            })
          );
          this.desserts = res;
          console.log(this.desserts);
        });
    },
    async inicio() {
      try {
        this.loading = true;
        db.collection(this.coleccion)
          .where(this.campo, this.condicion, this.consulta)
          .where("archivado", "==", true)
          .limit(this.itemsPerPage)
          .orderBy(this.ordenar, this.typoOrdenar)
          .onSnapshot(async (resul) => {
            this.lastVisible = resul.docs[resul.docs.length - 1] || null;
            this.firstVisible = resul.docs[0] || null;

            const res = await Promise.all(
              resul.docs.map(async (doc) => {
                const cliente =
                  doc.data().uidcliente &&
                  (await this.BuscarRegistro(
                    doc.data().uidcliente,
                    "clientes"
                  ));
                const abogado =
                  doc.data().uidabogado &&
                  (await this.BuscarRegistro(
                    doc.data().uidabogado,
                    "usuarios"
                  ));
                doc.data().uidabogado &&
                  this.logueado.cargo == "Abogado" &&
                  this.tomarCaso.push(doc.id);
                const dibujante =
                  doc.data().uiddibujante != "solicitado" &&
                  doc.data().uiddibujante &&
                  (await this.BuscarRegistro(
                    doc.data().uiddibujante,
                    "usuarios"
                  ));
                doc.data().uiddibujante != "solicitado" &&
                  doc.data().uiddibujante &&
                  this.logueado.cargo == "Dibujante" &&
                  this.tomarCaso.push(doc.id);
                const callcenter =
                  doc.data().uidcontactcenter &&
                  (await this.BuscarRegistro(
                    doc.data().uidcontactcenter,
                    "usuarios"
                  ));
                const investigador =
                  doc.data().uidinvestigador &&
                  (await this.BuscarRegistro(
                    doc.data().uidinvestigador,
                    "usuarios"
                  ));
                doc.data().uidinvestigador &&
                  this.logueado.cargo == "Investigador" &&
                  this.tomarCaso.push(doc.id);
                const perito =
                  doc.data().uidperito &&
                  (await this.BuscarRegistro(doc.data().uidperito, "usuarios"));
                const vehiculo =
                  doc.data().uidvehiculo &&
                  (await this.BuscarRegistro(
                    doc.data().uidvehiculo,
                    "vehiculos"
                  ));

                return {
                  id: doc.id,
                  ...doc.data(),
                  cliente: cliente
                    ? `${cliente.nombres} ${cliente.apellidos} ${cliente.identificacion}`
                    : "",
                  abogado: abogado
                    ? `${abogado.nombres} ${abogado.apellidos} ${abogado.identificacion}`
                    : "",
                  dibujante: dibujante
                    ? `${dibujante.nombres} ${dibujante.apellidos} ${dibujante.identificacion}`
                    : "",
                  callcenter: callcenter
                    ? `${callcenter.nombres} ${callcenter.apellidos} ${callcenter.identificacion}`
                    : "",
                  investigador: investigador
                    ? `${investigador.nombres} ${investigador.apellidos} ${investigador.identificacion}`
                    : "",
                  perito: perito
                    ? `${perito.nombres} ${perito.apellidos} ${perito.identificacion}`
                    : "",
                  vehiculo: vehiculo
                    ? `Placa: ${vehiculo.placa} Marca: ${vehiculo.marca}`
                    : "",
                  creado: moment(doc.data().creado).format(
                    "YYYY-MM-DD HH:mm:ss"
                  ),
                };
              })
            );
            this.desserts = res;
          });
      } catch (error) {
        this.handleError(error);
      }
    },
    async siguiente() {
      try {
        this.loading = true;
        db.collection(this.coleccion)
          .where(this.campo, this.condicion, this.consulta)
          .where("archivado", "==", true)
          .limit(this.itemsPerPage)
          .orderBy(this.ordenar, this.typoOrdenar)
          .startAfter(this.lastVisible)
          .get()
          .then(async (resul) => {
            this.lastVisible = resul.docs[resul.docs.length - 1] || null;
            this.firstVisible = resul.docs[0] || null;
            const res = await Promise.all(
              resul.docs.map(async (doc) => {
                const cliente =
                  doc.data().uidcliente &&
                  (await this.BuscarRegistro(
                    doc.data().uidcliente,
                    "clientes"
                  ));
                const abogado =
                  doc.data().uidabogado &&
                  (await this.BuscarRegistro(
                    doc.data().uidabogado,
                    "usuarios"
                  ));
                doc.data().uidabogado &&
                  this.logueado.cargo == "Abogado" &&
                  this.tomarCaso.push(doc.id);
                const dibujante =
                  doc.data().uiddibujante != "solicitado" &&
                  doc.data().uiddibujante &&
                  (await this.BuscarRegistro(
                    doc.data().uiddibujante,
                    "usuarios"
                  ));
                doc.data().uiddibujante != "solicitado" &&
                  doc.data().uiddibujante &&
                  this.logueado.cargo == "Dibujante" &&
                  this.tomarCaso.push(doc.id);
                const callcenter =
                  doc.data().uidcontactcenter &&
                  (await this.BuscarRegistro(
                    doc.data().uidcontactcenter,
                    "usuarios"
                  ));
                const investigador =
                  doc.data().uidinvestigador &&
                  (await this.BuscarRegistro(
                    doc.data().uidinvestigador,
                    "usuarios"
                  ));
                doc.data().uidinvestigador &&
                  this.logueado.cargo == "Investigador" &&
                  this.tomarCaso.push(doc.id);
                const perito =
                  doc.data().uidperito &&
                  (await this.BuscarRegistro(doc.data().uidperito, "usuarios"));
                const vehiculo =
                  doc.data().uidvehiculo &&
                  (await this.BuscarRegistro(
                    doc.data().uidvehiculo,
                    "vehiculos"
                  ));

                return {
                  id: doc.id,
                  ...doc.data(),
                  cliente: cliente
                    ? `${cliente.nombres} ${cliente.apellidos} ${cliente.identificacion}`
                    : "",
                  abogado: abogado
                    ? `${abogado.nombres} ${abogado.apellidos} ${abogado.identificacion}`
                    : "",
                  dibujante: dibujante
                    ? `${dibujante.nombres} ${dibujante.apellidos} ${dibujante.identificacion}`
                    : "",
                  callcenter: callcenter
                    ? `${callcenter.nombres} ${callcenter.apellidos} ${callcenter.identificacion}`
                    : "",
                  investigador: investigador
                    ? `${investigador.nombres} ${investigador.apellidos} ${investigador.identificacion}`
                    : "",
                  perito: perito
                    ? `${perito.nombres} ${perito.apellidos} ${perito.identificacion}`
                    : "",
                  vehiculo: vehiculo
                    ? `Placa: ${vehiculo.placa} Marca: ${vehiculo.marca}`
                    : "",
                  creado: moment(doc.data().creado).format(
                    "YYYY-MM-DD HH:mm:ss"
                  ),
                };
              })
            );
            this.desserts = res;
          });
      } catch (error) {
        this.handleError(error);
      }
    },
    async anterior() {
      try {
        this.loading = true;
        db.collection(this.coleccion)
          .where(this.campo, this.condicion, this.consulta)
          .where("archivado", "==", true)
          .limitToLast(this.itemsPerPage)
          .orderBy(this.ordenar, this.typoOrdenar)
          .endBefore(this.firstVisible)
          .get()
          .then(async (resul) => {
            this.lastVisible = resul.docs[resul.docs.length - 1] || null;
            this.firstVisible = resul.docs[0] || null;
            const res = await Promise.all(
              resul.docs.map(async (doc) => {
                const cliente =
                  doc.data().uidcliente &&
                  (await this.BuscarRegistro(
                    doc.data().uidcliente,
                    "clientes"
                  ));
                const abogado =
                  doc.data().uidabogado &&
                  (await this.BuscarRegistro(
                    doc.data().uidabogado,
                    "usuarios"
                  ));
                doc.data().uidabogado &&
                  this.logueado.cargo == "Abogado" &&
                  this.tomarCaso.push(doc.id);
                const dibujante =
                  doc.data().uiddibujante != "solicitado" &&
                  doc.data().uiddibujante &&
                  (await this.BuscarRegistro(
                    doc.data().uiddibujante,
                    "usuarios"
                  ));
                doc.data().uiddibujante != "solicitado" &&
                  doc.data().uiddibujante &&
                  this.logueado.cargo == "Dibujante" &&
                  this.tomarCaso.push(doc.id);
                const callcenter =
                  doc.data().uidcontactcenter &&
                  (await this.BuscarRegistro(
                    doc.data().uidcontactcenter,
                    "usuarios"
                  ));
                const investigador =
                  doc.data().uidinvestigador &&
                  (await this.BuscarRegistro(
                    doc.data().uidinvestigador,
                    "usuarios"
                  ));
                doc.data().uidinvestigador &&
                  this.logueado.cargo == "Investigador" &&
                  this.tomarCaso.push(doc.id);
                const perito =
                  doc.data().uidperito &&
                  (await this.BuscarRegistro(doc.data().uidperito, "usuarios"));
                const vehiculo =
                  doc.data().uidvehiculo &&
                  (await this.BuscarRegistro(
                    doc.data().uidvehiculo,
                    "vehiculos"
                  ));

                return {
                  id: doc.id,
                  ...doc.data(),
                  cliente: cliente
                    ? `${cliente.nombres} ${cliente.apellidos} ${cliente.identificacion}`
                    : "",
                  abogado: abogado
                    ? `${abogado.nombres} ${abogado.apellidos} ${abogado.identificacion}`
                    : "",
                  dibujante: dibujante
                    ? `${dibujante.nombres} ${dibujante.apellidos} ${dibujante.identificacion}`
                    : "",
                  callcenter: callcenter
                    ? `${callcenter.nombres} ${callcenter.apellidos} ${callcenter.identificacion}`
                    : "",
                  investigador: investigador
                    ? `${investigador.nombres} ${investigador.apellidos} ${investigador.identificacion}`
                    : "",
                  perito: perito
                    ? `${perito.nombres} ${perito.apellidos} ${perito.identificacion}`
                    : "",
                  vehiculo: vehiculo
                    ? `Placa: ${vehiculo.placa} Marca: ${vehiculo.marca}`
                    : "",
                  creado: moment(doc.data().creado).format(
                    "YYYY-MM-DD HH:mm:ss"
                  ),
                };
              })
            );
            this.desserts = res;
          });
      } catch (error) {
        this.handleError(error);
      }
    },
    addUpdate(item = "") {
      if (!this.autorizaCrear) {
        this.$swal({
          icon: "info",
          title: "Oops...",
          text: "Usuario no autorizado",
        });
        return;
      }
      this.id = item.id;
      this.showModal = true;
    },
    autorizar(item) {
      this.id = item.id;
      this.numero_caso = item.caso;
      this.uidcontactcenter = item.uidcontactcenter;
      this.$swal({
        title: "",
        text: `¿Esta seguro de autorizar asistencia especial al caso # ${this.numero_caso}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Si, Autorizar !!",
        cancelButtonText: "No",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.value) {
          db.collection(this.coleccion)
            .doc(item.id)
            .update({ aprobar_atencion: true });
          // se guarda la trazabilidad del caso
          this.$store.dispatch("trazabilidadCaso", {
            descripcion: "Se autoriza la atención del caso",
            uidcaso: item.id,
            uidcreador: this.logueado.id,
          });
          //TODO: ENVIAR NOTIFICACIÓN AL ASESOR ASOCIADO AL CASO
          this.envioNotificacion();
          this.$swal("Operación Exitosa", "", "success");
          this.getData();
        }
      });
    },
    async envioNotificacion() {
      const usuarios = await db
        .collection("usuarios")
        .where("uidcontactcenter", "==", this.uidcontactcenter)
        .get();

      const objUsuNotificar = usuarios.docs.map((e) => ({
        ...e.data(),
      }));

      const usu = objUsuNotificar
        .filter((e) => {
          return e.tokenPush;
        })
        .map((u) => {
          return u.tokenPush;
        });

      this.registration_ids = [...usu];
      this.EnviarNotificaciones({
        registration_ids: this.registration_ids,
        title: "Autorización",
        message: `Se autoriza la atención del caso #${this.numero_caso}`,
      });
    },
    archivar(item = "") {
      this.id = item.id;
      this.$swal({
        title: "",
        text: `¿Deseas restablecer el caso # ${item?.caso}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Si, Restablecer !!",
        cancelButtonText: "Cancelar",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.value) {
          db.collection(this.coleccion)
            .doc(item.id)
            .update({ archivado: false });
          this.$swal("Caso Activado", "", "success");
          this.getData();
        }
      });
    },
    infoCaso(item) {
      this.showModalAfectado = true;
      this.id = item.id;
    },
    async actualizarEstadoAgente() {
      // consultamos la cantidad de caso en los que esta asociado para determinar el estado
      for (const el of this.agentes) {
        if (el == "uidabogado") {
          if (!this.datosCaso.uidabogado) continue;
          this.campoAgente = "uidabogado";
          this.consultaAgente = this.datosCaso.uidabogado;
          this.cargoAgente = "Abogado";
        } else if (el == "uidabogadocait") {
          if (!this.datosCaso.uidabogadocait) continue;
          this.campoAgente = "uidabogadocait";
          this.consultaAgente = this.datosCaso.uidabogadocait;
          this.cargoAgente = "Abogado CAIT";
        } else if (el == "uidcontactcenter") {
          if (!this.datosCaso.uidcontactcenter) continue;
          this.campoAgente = "uidcontactcenter";
          this.consultaAgente = this.datosCaso.uidcontactcenter;
          this.cargoAgente = "Call Center";
        } else if (el == "uidinvestigador") {
          if (!this.datosCaso.uidinvestigador) continue;
          this.campoAgente = "uidinvestigador";
          this.consultaAgente = this.datosCaso.uidinvestigador;
          this.cargoAgente = "Investigador";
        } else if (el == "uidperito") {
          if (!this.datosCaso.uidperito) continue;
          this.campoAgente = "uidperito";
          this.consultaAgente = this.datosCaso.uidperito;
          this.cargoAgente = "Perito";
        }
        try {
          const result = await db
            .collection("casos")
            .where(this.campoAgente, "==", this.consultaAgente)
            .where("archivado", "==", true)
            .where("estado", "not-in", [
              "Cancelado",
              "Conciliado",
              "No conciliado",
            ])
            .get();
          this.estadoAgente =
            result.size > 1 ? "Activo multiple" : "Activo ocupado";
          await db
            .collection("usuarios")
            .doc(this.consultaAgente)
            .update({ disponibilidad: this.estadoAgente });
          console.log("se actualiza el estado del usuario", this.campoAgente);
          if (
            this.datosCaso.estado === "Cancelado" ||
            this.datosCaso.estado === "Conciliado" ||
            this.datosCaso.estado === "No conciliado"
          ) {
            return;
          }
          this.trazabilidadEstadoUsuarios({
            descripcion: `El ${this.cargoAgente} ha sido liberado del caso # ${this.datosCaso.caso}`,
            estado: this.estadoAgente,
            uidcaso: this.id,
            cargo: this.cargoAgente,
            uidcreador: this.logueado.id,
            uidusuario: this.consultaAgente,
          });
        } catch (error) {
          console.log(error);
          this.handleError(error);
        }
      }
    },
    async exportar(item) {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Access-Control-Allow-Origin", "*");

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      try {
        const { isConfirmed = false } = await this.$swal({
          title: "Esta seguro de querer exportar los archivos del caso?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Si, Exportar",
        });
        if (isConfirmed) {
          fetch(
            `${process.env.VUE_APP_CLOUDFUNCTIONURL}/generarSftp?casoId=${item.id}&token=${this.logueado.tokenPush}`,
            requestOptions
          )
            .then((response) => response.json())
            .then((result) =>
              this.$swal({
                icon: "info",
                title: "OK",
                text: result.messages,
              })
            )
            .catch((error) => console.log("error", error));
        }
      } catch ({ messages }) {
        const { error = "error no identificado" } = messages;
        this.$swal({ icon: "error", title: "Oops...", text: error });
      }
    },
    async enviarNotificacion(tipo, usuario) {
      try {
        const objCaso = await db.collection("casos").doc(this.id).get();
        const { uidconductor, caso, uidcontactcenter } = objCaso.data();
        this.numero_caso = caso;
        if (uidconductor) {
          const objCliente = await db
            .collection("clientes")
            .doc(uidconductor)
            .get();
          const objAsesor = await db
            .collection("usuarios")
            .doc(uidcontactcenter)
            .get();
          // console.log(objCliente.data());
          // TODO: MEJORAR TAJER CALVO
          const objDatosCliente = objCliente.data();
          const objDatosAsesor = objAsesor.data();
          let tokenPush = [];
          tokenPush.push(objDatosCliente.tokenPush);
          tokenPush.push(objDatosAsesor.tokenPush);
          if (tokenPush) {
            // Enviar notificacion ORG
            await this.EnviarNotificaciones({
              registration_ids: tokenPush,
              title: "CASO ASIGNADO",
              message: `EL ${tipo.toUpperCase()} ${usuario.toUpperCase()} HA SIDO ASIGNADO AL CASO # ${
                this.numero_caso
              }`,
              url: this.url,
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>

<style src="./Caso.scss" lang="scss"></style>
